import { api } from '../helpers';

export const getPosts = (params) => {
	return api('/Post/GetList', 'GET', null, params);
};

export const getPostDetail = (payload) => {
	return api('/Post/GetDetail?id=' + payload.id, 'GET');
};
